const swagger = {
    invalid_zod_type: '유효하지 않은 Zod 종류에요. Route Guard 설정을 확인해 주세요.',
    not_supported_zod_type_for_params: '지원되지 않는 Zod 종류예요. Route Guard 설정을 확인해 주세요.',
};
export default Object.freeze(swagger);
